import styles from './Format.module.css';
import { DataResult } from '../model/DataResult';

interface TextFormatProps extends DataResult {
  className?: string;
}

export default function TextFormat({
  textValue = '',
  outsideBenchmark = false,
  className = ''
}: TextFormatProps) {
  return (
    <p
      className={`${styles.container} ${outsideBenchmark ? styles.outside_benchmark : ''} ${className}`.trim()}>
      {textValue !== 'null' ? textValue : ''}
    </p>
  );
}
